export default __webpack_public_path__ + "static/media/dingtalk-square.bc6bfa5c.svg";